export const en = {
  logout: "Logout",
  error_contact_support:
    "An error occurred. Please contact support so we can help you.",
  login_google: "Login with Google",
  card_input_mode_changed: "Card input mode has been changed",
  card_input_mode_manual: "Manual input",
  card_input_mode_type: "If you type",
  card_input_mode_get: "You'll get a card like this",
  card_input_mode_screen: "Card input mode",
  generate: "Generate",
  folder_form_no_decks: "No decks in the folder",
  cards_add: "Add cards",
  card_next: "Next",
  card_previous: "Previous",
  user_stats_empty_text: "Study more cards to see the data",
  read_more: "Read more",
  hide_card_forever: "Hide forever",
  mute_cards: "Mute sound",
  unmute_cards: "Unmute sound",
  hide_card_forever_confirm_title:
    "Are you sure you want to hide this card forever? You will never see it again",
  wysiwyg_big_header: "Big header",
  next: "Next",
  custom_due_cards: "Due cards",
  custom_new_cards: "New cards",
  review_custom: "Custom review",
  review_card_type: "Type of card",
  wysiwyg_text_color: "Text color",
  wysiwyg_bold: "Bold",
  wysiwyg_italic: "Italic",
  wysiwyg_undo: "Undo",
  wysiwyg_clear_formatting: "Clear formatting",
  my_decks: "My decks",
  formatting: "Formatting",
  deck: "Deck",
  deck_description: "A collection of cards",
  folder: "Folder",
  folder_description: "A collection of decks",
  decks: "Decks",
  edit_folder: "Edit folder",
  add_folder: "Add folder",
  add_deck_to_folder: "Add deck to the folder",
  decks_in_other_folders: "Decks in other folders",
  no_decks_to_add: "No more decks to add",
  show_all_decks: "Show all",
  hide_all_decks: "Hide",
  select_all: "Select all",
  deselect_all: "Deselect all",
  select: "Select",
  selected: "Selected",
  browser_no_personal_decks_start: "You don't have any personal deck yet",
  browser_no_personal_decks_link: "Learn how to use MemoCard on ",
  browser_no_personal_decks_end: ". Happy learning! 😊",
  add_deck: "Add deck",
  add: "Add",
  edit_deck: "Edit deck",
  edit: "Edit",
  view: "View",
  all_decks_reviewed: `Amazing work! 🌟 You've reviewed all the decks for now. Come back later for more.`,
  public_decks: "Public decks",
  explore_public_decks: "Explore more decks",
  news_and_updates: "News and updates",
  youtube_channel: "YouTube channel",
  profile_section: "Profile",
  telegram_channel: "Telegram channel",
  settings: "Settings",
  deck_has_been_added: "This deck is on your list",
  deck_catalog: "Deck Catalog",
  translated_to: "Translated to",
  any_language: "Any language",
  category: "Category",
  any_category: "Any",
  deck_search_not_found: "No decks found",
  deck_search_not_found_description: "Try updating filters to see more decks",
  card_search_not_found: "No cards found",
  category_English: "English",
  category_Thai: "Thai",
  category_Geography: "Geography",
  category_History: "History",
  category_Chemistry: "Chemistry",
  category_Spanish: "Spanish",
  category_Other: "Other",
  save: "Save",
  add_card: "Add card",
  edit_card: "Edit card",
  card_preview: "Preview",
  add_card_short: "Add card",
  add_deck_short: "Deck",
  card_front_title: "Front side",
  card_back_title: "Back side",
  card_front_side_hint: "The prompt or question",
  card_back_side_hint: "The response you need to provide",
  card_field_example_title: "Example",
  card_field_example_hint: "Optional additional information",
  cards: "Cards",
  search_card: "Search card",
  card_sort_by_date: "Date",
  card_sort_by_front: "Front",
  card_sort_by_back: "Back",
  sort_by: "Sort by",
  title: "Title",
  description: "Description",
  speaking_cards: "Speaking cards",
  voice_language: "Voice language",
  card_speak_side: "Speak side",
  front: "Front",
  back: "Back",
  card_speak_description:
    "Play spoken audio for each flashcard to listen to the pronunciation",
  review_deck_finished: `You have finished this deck for now 🎉`,
  review_all_cards: `You have repeated all the cards for today 🎉`,
  review_finished_want_more: "Want more? You have",
  review_finished_to_review: "to study",
  review_deck: "Review deck",
  review_folder: "Review folder",
  cards_to_repeat: "To repeat",
  cards_new: "New cards",
  cards_total: "Total cards",
  duplicate: "Duplicate",
  duplicate_deck_confirm: "Are you sure to duplicate this deck?",
  duplicate_folder_confirm: "Are you sure to duplicate this folder?",
  delete_deck_confirm_shared: "Remove deck from your collection?",
  delete_folder_confirm_shared: "Remove folder from your collection?",
  delete_deck_confirm_author:
    "Remove deck from MemoCard? This action can't be undone",
  delete_folder_confirm_author:
    "Remove folder from MemoCard? This action can't be undone",
  deck_form_remove_card_confirm:
    "Are you sure you want to remove the card? All the card reviews from all the users will be lost",
  deck_form_remove_cards_confirm:
    "Are you sure you want to remove all of the selected cards?",
  delete: "Delete",
  no_cards_to_review_in_deck: `Amazing work! 🌟 You've reviewed all the cards in this deck for now. Come back later for more.`,
  repeat_cards_anyway: `Repeat cards anyway`,
  no_cards_to_review_all: `Amazing work! 🌟 You've repeated all the cards for today. Come back later for more.`,
  review_again: "Again",
  review_hard: "Hard",
  review_good: "Good",
  review_easy: "Easy",
  review_show_answer: "Show answer",
  share: "Share",
  warning_telegram_outdated_title: "Your Telegram is outdated",
  warning_telegram_outdated_description:
    "Please update your Telegram to ensure stable functioning of this app.",
  settings_review_notifications: "Review notifications",
  settings_time: "Time",
  settings_lang: "Language",
  settings_review_notifications_hint:
    "Daily reminders help you remember to repeat cards",
  validation_deck_title: "The deck title is required",
  deck_form_quit_card_confirm: "Quit editing card without saving?",
  quit_without_saving: "Quit without saving?",
  folder_form_quit_card_confirm: "Quit editing folder without saving?",
  deck_form_quit_deck_confirm: "Quit editing deck without saving?",
  deck_category: "Deck category",
  validation_required: "This field is required",
  share_link_copied: "The link has been copied to your clipboard",
  copied: "Copied",
  copy_code: "Copy code",
  html_column: "Column",
  html_row: "Row",
  settings_contact_support: "Contact support in Telegram",
  settings_support_hint: "If you have any issues, questions or suggestions",
  payment_description: "Unlock more features ",
  payment_choose_duration: "Duration",
  payment_choose_subscription: "Subscription",
  payment_choose_method: "Payment method",
  payment_method_usd: "Bank card",
  payment_method_stars: "Telegram stars",
  payment_included: "What's included",
  payment_paid_until: "Paid until",
  ai_cards_left: "AI cards left this month",
  payment_tos_and_pp_agree: "By purchasing MemoCard you agree to the ",
  payment_tos: "Terms of Service",
  payment_and: " and ",
  payment_pp: "Privacy Policy",
  privacy_policy: "Privacy Policy",
  go_back: "Back",
  validation_at_least_one_deck: "Please select at least 1 deck",
  add_answer: "Add quiz answer",
  answer_text: "Answer text",
  review_correct_label: "Correct",
  review_wrong_label: "Incorrect",
  advanced: "More",
  review_idk: "I don't know",
  card_answer_type: "Card type",
  yes_no: "Remember",
  yes: "Yes",
  answer_type_choice: "Quiz",
  answer_type_explanation_remember: `A card with "Remember" and "Don't remember" buttons`,
  answer_type_explanation_choice: `A card with answer choices`,
  validation_answer_at_least_one_correct:
    "One answer should be selected as correct",
  validation_at_least_one_answer_required:
    "At least one answer should be provided",
  user_stats_btn: "Statistics",
  user_stats_page: "My statistics",
  user_stats_remembered: "Remembered",
  user_stats_remembered_hint:
    "The number of cards reviewed correctly 5 times in a row",
  user_stats_learning: "Learning",
  user_stats_learning_hint:
    "The number of cards reviewed less than 5 times in a row",
  user_stats_total: "Total cards",
  user_stats_total_hint: "The total number of cards opened at least once",
  user_stats_learning_time: "Learning time distribution",
  user_stats_learning_time_hint:
    "How your time is allocated between learning new material and reviewing",
  user_stats_chart_min_expl: "Don't know the card",
  user_stats_chart_max_expl: "Know the card very well",
  validate_positive: "Please enter a positive number",
  validate_under_100: "Please enter a number less than 100",
  freeze_confirm_freeze:
    "Are you sure you want to freeze your cards? This action can't be undone.",
  freeze_title: "Freeze cards",
  how: "How it works",
  freeze_rule_1:
    "All your cards will be paused, and you won't receive any notifications.",
  freeze_rule_2:
    "The amount of cards to review won't increase during the frozen period; you'll see the same number of cards when you resume.",
  freeze_rule_3: "Freezing cards can't be undone.",
  freeze_rule_4:
    "If you add a card during the freeze period, it will not be affected by the freeze.",
  freeze_for: "Freeze for",
  freeze_for_or_manual: "or type manually",
  freeze_notified: "You'll get notified on",
  freeze_hint: "Postpone studying cards",
  ui_loading: "Loading...",
  is_on: "On",
  is_off: "Off",
  error_solving: "We're solving the issue",
  error: "Error",
  user_settings_updated: "Settings have been updated",
  ai_cards_generate: "Generate cards",
  ai_cards_title: "Generate cards with AI",
  ai_cards_previous_prompts: "Prompt history",
  ai_cards_no_previous_prompts: "No previous prompts",
  ai_cards_prompt: "Prompt",
  ai_cards_prompt_front: "Card front",
  ai_cards_prompt_back: "Card back",
  ai_cards_by_ai: "Cards generated by AI",
  ai_cards_confirm_delete: "Are you sure you want to delete this card?",
  ai_cards_added: "Cards have been added",
  ai_cards_use_template: "Use template",
  payment_success: "Payment is successful. Enjoy additional features 😊",
  confirm_cancel: "Cancel",
  confirm_ok: "Confirm",

  upgrade_pro: "Upgrade to Pro",

  payment_failed:
    "Payment failed. We're aware of the issue and working on it. Please contact support via Settings > Support.",

  ai_speech_preview_free_title: "Standard voice",
  ai_speech_preview_free_desc: "Free robotic voice",
  ai_speech_preview_pro_desc: "High-quality voice with natural intonation",
  ai_speech_preview_free_lbl: "Free",
  ai_speech_lang_support: "Supports 30+ languages",
  ai_speech_listen: "Listen sample",
  voice_type_none: "None",

  ai_card_input_mode_supports: "Different languages are supported",

  ai_speech_title: "AI speech",
  ai_speech_empty: "No AI speech generated. Choose the card side below.",
  ai_speech_type: "Or type the needed text",
  ai_speech_generate: "Generate",
  ai_speech_validate: "Please either select side or type the text",

  // Global Search
  global_search_placeholder: "Search decks, folders, cards",
  global_search_no_results: "No results found",
  global_search_cancel: "Cancel",
  global_search_start_typing:
    "Start typing to search for decks, folders, and cards",
  global_search_tabs_cards: "Cards",
  global_search_tabs_decks: "Decks",
  global_search_tabs_folders: "Folders",
  global_search_context_folder: "Folder",
  global_search_context_deck: "Deck",

  // About page
  about_title: "About",
  about_paragraph_1:
    "MemoCard was born because existing apps like Anki are just too clunky. Sure, they're powerful, but they demand endless setup, don't remind you when it matters, and look like they're stuck in the past.",
  about_paragraph_2:
    "During the Telegram Mini App Contest, I built the flashcard app I'd been dreaming of. Zero configuration needed, smart reminders, and an interface that just makes sense.",
  about_paragraph_3:
    "Under the hood is Ebbinghaus's proven spaced repetition method. Cards pop up exactly when you're starting to forget - that's when your brain learns best.",
  about_paragraph_4:
    "MemoCard won a prize at the contest. Now thousands of people around the world use it to learn better.",
  about_visit_website: "Visit Website →",
  about_github_frontend: "GitHub Frontend Repository →",

  // Card Input Mode Form
  card_input_mode_form_title: "Title",
  card_input_mode_form_ai_prompt: "AI Prompt",
  card_input_mode_form_create_title: "Create input mode",
  card_input_mode_form_edit_title: "Edit input mode",
  card_input_mode_form_delete_confirm: "Delete this input mode?",
  card_input_mode_add_button: "Add input mode",
  card_input_mode_form_title_placeholder: "e.g. English Definitions",
  card_input_mode_form_prompt_placeholder:
    "e.g. Generate a definition flashcard for the word :template_word",
  card_input_mode_form_front_placeholder: "e.g. Word or term",
  card_input_mode_form_back_placeholder: "e.g. Simple definition",
  card_input_mode_form_example_placeholder: "e.g. Usage example or context",
  card_input_mode_form_save_success: "Input mode saved",
  card_input_mode_form_delete_success: "Input mode deleted",
  quit_card: "Quit card",

  // Wysiwyg Help
  wysiwyg_help_title: "Text Formatting Guide",
  wysiwyg_help_step1: "Highlight the text you want to change",
  wysiwyg_help_step2: "Press any button from the toolbar",
  wysiwyg_help_bold: "Bold text",
  wysiwyg_help_italic: "Italic text",
  wysiwyg_help_color: "Change text color",
  wysiwyg_help_heading: "Make text bigger (heading)",
  wysiwyg_help_table: "Insert a table",
  wysiwyg_help_clear: "Remove all formatting",
  wysiwyg_help_undo: "Undo last action",

  reverse_cards: "Reverse cards",
  reverse_cards_title: "Reverse Cards",
  reverse_cards_helper:
    "Get 2 cards from a single entry. Helps remember better",
  two_cards_created: "2 cards have been created",
  card_created: "Card has been created",

  // Move card to deck
  move_card_to_deck_title: "Move to deck",
  move_card_without_folder: "Without folder",
  move_card_move: "Move",
  move_card_open_deck: "Open deck",

  // Image related
  image: "Image",

  // Skip card
  skip_card_for_now: "Skip for now",
  skip_card_confirm: "Skip this card? It will be hidden until your next review",
  review_skipped: "Skipped",
};

export type Translation = typeof en;
